var Curriculog = Curriculog || {};

Curriculog.RoleView = (function ($, _, Backbone, RoleView) {

	RoleView = Curriculog.HierarchyListView.extend({
		template: 'HierarchyList/roleListItem.html',

		initialize: function (options) {
			this.userRoleViews = {};
			this.users = options.users;
			this.depth = options.depth;
			this.committees = options.committees;

			this.roleID = this.model.get('id');
			this.userRoles = options.userRoles.getUserRolesForRole(this.roleID);
			this.userRoleCollection = options.userRoles;
      this.params = options.params;
			this.render();
		},

		render: function () {
			templateData = this.model.toJSON();
			templateData['depth'] = this.depth;
			templateData['userRoles'] = this.userRoles;
      templateData['cui_enabled'] = this.params.cui_enabled;

			var committeeID = this.model.get('committee_id');
			if (committeeID !== null) {
				templateData['committee'] = this.committees.get(committeeID).toJSON();
			}

			this.el = nunjucks.render(this.template, templateData);
			this.replaceElement(this.el);
			this.renderUserRoles();
		},

		renderUserRoles: function () {
			var userList = []
			for (var i = 0; i < this.userRoles.length; i++) {
				userRoleRecord = this.userRoles[i];
				userID = userRoleRecord.get('user_id');
				userModel = this.users.get(userID);

				// It is possible that a deleted user still has a user_role
				// record, so we must make sure we actually have a user model
				// for each user.
				if (typeof userModel !== 'undefined') {
					userList.push(userModel);
				}
			}

			// sort users by their last name
			sortedUserList = this.sortUserRoles(userList);

			var views = [];
			for (var i = 0; i < sortedUserList.length; i++) {
				var userModel = sortedUserList[i];
				var userRoleRecord = this.userRoleCollection.findWhere({
					role_id: this.roleID,
					user_id: userModel.get('id'),
				});

				var userRoleView = new Curriculog.UserRoleView({
					user: userModel,
					users: this.users,
					depth: this.depth,
					userRole: userRoleRecord,
          params: this.params
				});
				this.userRoleViews[userID] = userRoleView;
				views.push(userRoleView.el);
			}
			this.$('.item-users').append(views);
		},

		sortUserRoles: function (listitems) {
			// Precache the uppercase version of the last name so we dont have
			// to recalculate it for each comparison while sorting.
			for(var i = 0, l = listitems.length; i < l; i++){
				listitems[i].lastNameUpper = listitems[i].get('last_name').toUpperCase();
			}

			// sort users by their last name
			listitems.sort(function(a, b) {
				return a.lastNameUpper.localeCompare(b.lastNameUpper);
			})

			return listitems
		},
	});

	return RoleView;

})($, _, Backbone, Curriculog.RoleView || {});
